/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Theme } from '@mui/material'

export const tableContainerStyle = (theme: Theme) => css`
  margin: ${theme.spacing(3)} 0;
  border-radius: ${typeof theme.shape.borderRadius === 'number'
    ? theme.shape.borderRadius * 2 + 'px'
    : `calc(${theme.shape.borderRadius} * 2)`};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  border: 1px solid #e5e5e5;

  @media (max-width: 768px) {
    font-size: 0.875rem;
  }
`

export const tableStyle = (theme: Theme) => css`
  width: 100%;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;

  & .MuiTableCell-root {
    padding: ${theme.spacing(1.5)} ${theme.spacing(2)};
    border-bottom: 1px solid #f0f0f0;
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
    vertical-align: top;
  }

  @media (max-width: 768px) {
    font-size: 0.875rem;
  }
`

export const tableHeadStyle = (theme: Theme) => css`
  background: linear-gradient(135deg, #4a5568 0%, #718096 100%);

  & .MuiTableCell-root {
    color: white;
    font-weight: 700;
    font-size: 13px;
    line-height: 1.4;
    letter-spacing: 0.3px;
    border-bottom: none;
    padding: ${theme.spacing(2.5)} ${theme.spacing(2)};
    text-align: center;
    vertical-align: middle;
    white-space: normal;
    word-break: break-word;
    hyphens: auto;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);

    &:first-of-type {
      text-align: left;
      font-weight: 800;
      background: rgba(0, 0, 0, 0.15);
      border-right: 1px solid rgba(255, 255, 255, 0.2);
    }

    @media (max-width: 768px) {
      font-size: 11px;
      padding: ${theme.spacing(2)} ${theme.spacing(1.5)};
      line-height: 1.3;
    }
  }
`

export const tableHeaderCellStyle = (showTooltip: boolean) => css`
  cursor: ${showTooltip ? 'help' : 'default'};
`

export const tableCellStyle = (theme: Theme) => css`
  &:first-of-type {
    font-weight: 600;
    background-color: #f6f6f6;
    border-right: 2px solid #e9ecef;
    position: sticky;
    left: 0;
    z-index: 1;

    @media (max-width: 768px) {
      font-size: 0.8rem;
      min-width: 60px;
      padding: ${theme.spacing(1)} ${theme.spacing(0.8)};
    }
  }

  &:not(:first-of-type) {
    text-align: center;
    font-variant-numeric: tabular-nums;
  }

  @media (max-width: 768px) {
    padding: ${theme.spacing(1)} ${theme.spacing(0.5)};
    font-size: 0.75rem;
    min-width: 50px;
  }
`
